import styled from 'styled-components';

export const Body = styled.div`
  overflow-x: hidden;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 80px;
  background: white;
  min-height: 100vh;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const FacilityInfo = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  border-bottom: 1px solid #E5E5E5;
`;

export const FacilityImage = styled.div`
  width: 60px;
  height: 60px;
  background-color: #E5E5E5;
  border-radius: 8px;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const FacilityDetails = styled.div`
  flex: 1;
  text-align: left;
`;

export const FacilityName = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: #333;
  margin-bottom: 4px;
`;

export const FacilityLocation = styled.div`
  font-size: 14px;
  color: #666;
`;

export const CalendarContainer = styled.div`
  padding: 20px;
`;

export const WeekHeader = styled.div`
  display: grid;
  grid-template-columns: 40px repeat(7, 1fr);
  gap: 0;
  margin-bottom: 0;
  border: 1px solid #E5E5E5;
  border-bottom: none;
`;

export const TimeColumn = styled.div`
  background: white;
  border-right: 1px solid #E5E5E5;
  border-bottom: 1px solid #E5E5E5;
`;

export const DayHeader = styled.div`
  text-align: center;
  padding: 12px 4px;
  font-size: 14px;
  font-weight: 500;
  color: #333;
  border-right: 1px solid #E5E5E5;
  background: white;

  &:last-child {
    border-right: none;
  }

  .day {
    display: block;
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
  }

  .date {
    display: block;
    font-size: 16px;
    font-weight: 600;
  }
`;

export const TimeGrid = styled.div`
  display: grid;
  grid-template-columns: 40px repeat(7, 1fr);
  border: 1px solid #E5E5E5;
  border-top: none;
  position: relative;
`;

export const TimeSlot = styled.div`
  height: 60px;
  border-bottom: 1px solid #E5E5E5;
  border-right: 1px solid #E5E5E5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #666;
  background: white;
`;

export const DayColumn = styled.div`
  position: relative;
  border-right: 1px solid #E5E5E5;

  &:last-child {
    border-right: none;
  }
`;

export const DayCell = styled.div`
  height: 60px;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
  background: white;

  &:first-child {
    border-top: 1px solid #E5E5E5;
  }
`;

export const EventBlock = styled.div<{ height: number; top: number }>`
  position: absolute;
  left: 2px;
  right: 2px;
  top: ${props => props.top}px;
  height: ${props => props.height}px;
  background-color: #5C5D61;
  color: white;
  font-size: 11px;
  padding: 4px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

export const GreenEventBlock = styled(EventBlock)`
  background-color: #4CAF50;
`;
